export const selectNotices = state => state.notices.notices;
export const selectOneNotice = state => state.notices.oneNotice;
export const selectIsNotLoading = state => state.notices.isLoading;
export const selectTotalPages = state => state.notices.totalPages;
